"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.moveCopyUsersToGroupSaveRequest = exports.moveCopyUserToGroup = exports.toggleMoveCopyUserToGroup = exports.deleteUsersFailure = exports.deleteUsersSuccess = exports.deleteUsersRequest = exports.deleteEdit = exports.setUserGroupName = exports.modifyProjectUserGroup = exports.deleteGroupsUsersFailure = exports.deleteGroupsUsersSuccess = exports.deleteGroupsUsersRequest = exports.updateTRMVRMeterFailure = exports.updateTRMVRMeterSuccess = exports.updateTRMVRMeterRequest = exports.createTRMVRMeterFailure = exports.createTRMVRMeterSuccess = exports.createTRMVRMeterRequest = exports.updateWorksiteDiaryFailure = exports.updateWorksiteDiarySuccess = exports.updateWorksiteDiaryRequest = exports.createWorksiteDiaryFailure = exports.createWorksiteDiarySuccess = exports.createWorksiteDiaryRequest = exports.updateUserProfileFailure = exports.updateUserProfileSuccess = exports.updateUserProfileRequest = exports.createUserProfileFailure = exports.createUserProfileSuccess = exports.createUserProfileRequest = exports.updateCategoryFailure = exports.updateCategorySuccess = exports.updateCategoryRequest = exports.deleteGroupFailure = exports.deleteGroupSuccess = exports.deleteGroupRequest = exports.createCategoryFailure = exports.createCategorySuccess = exports.createCategoryRequest = exports.deleteUsersFromProjectFailure = exports.deleteUsersFromProjectSuccess = exports.deleteUsersFromProjectRequest = exports.updateUserGroupSelectBox = exports.updateUserGroupEmail = exports.toggleModal = exports.setTab = exports.setFeature = exports.clearState = exports.UsergroupInvite = exports.UsergroupList = void 0;
exports.moveCopyUsersToGroupSaveSuccess = exports.moveCopyUsersToGroupSaveFailure = void 0;
const ActionTypes = require("../../actionTypes/project/members");
const _usergroupInvite = require("../../modules/usergroup/invite/actions");
const _usergroupList = require("../../modules/usergroup/list/actions");
exports.UsergroupList = _usergroupList.default('project/members');
exports.UsergroupInvite = _usergroupInvite.default('project/members');
// State
const clearState = () => ({
    type: ActionTypes.CLEAR_STATE
});
exports.clearState = clearState;
// UI actions
const setFeature = (feature, status) => ({
    type: ActionTypes.SET_FEATURE,
    payload: {
        feature,
        status
    }
});
exports.setFeature = setFeature;
function setTab(tab) {
    return {
        type: ActionTypes.SET_TAB,
        tab
    };
}
exports.setTab = setTab;
const toggleModal = () => ({
    type: ActionTypes.TOGGLE_MODAL
});
exports.toggleModal = toggleModal;
const updateUserGroupEmail = (uuid, emails) => ({
    type: ActionTypes.UPDATE_USER_GROUP_EMAIL,
    payload: {
        uuid,
        emails
    }
});
exports.updateUserGroupEmail = updateUserGroupEmail;
const updateUserGroupSelectBox = (uuid, newId, name) => ({
    type: ActionTypes.UPDATE_USER_GROUP_SELECT_BOX,
    payload: {
        uuid,
        newId,
        name
    }
});
exports.updateUserGroupSelectBox = updateUserGroupSelectBox;
// User
// export type SelectedUser = {
//   groupId: number
//   userId: number
// }
const deleteUsersFromProjectRequest = (projectId, users) => ({
    type: ActionTypes.DELETE_USERS_FROM_PROJECT_REQUEST,
    payload: {
        projectId,
        users
    }
});
exports.deleteUsersFromProjectRequest = deleteUsersFromProjectRequest;
const deleteUsersFromProjectSuccess = () => ({
    type: ActionTypes.DELETE_USERS_FROM_PROJECT_SUCCESS
});
exports.deleteUsersFromProjectSuccess = deleteUsersFromProjectSuccess;
const deleteUsersFromProjectFailure = (error) => ({
    type: ActionTypes.DELETE_USERS_FROM_PROJECT_FAILURE,
    payload: error
});
exports.deleteUsersFromProjectFailure = deleteUsersFromProjectFailure;
// User category
const createCategoryRequest = (projectId, name, description) => ({
    type: ActionTypes.CREATE_CATEGORY_REQUEST,
    payload: {
        projectId,
        name,
        description
    }
});
exports.createCategoryRequest = createCategoryRequest;
const createCategorySuccess = () => ({
    type: ActionTypes.CREATE_CATEGORY_SUCCESS
});
exports.createCategorySuccess = createCategorySuccess;
const createCategoryFailure = (error) => ({
    type: ActionTypes.CREATE_CATEGORY_FAILURE,
    payload: error
});
exports.createCategoryFailure = createCategoryFailure;
function deleteGroupRequest(projectId, group) {
    return {
        type: ActionTypes.DELETE_GROUP_REQUEST,
        payload: { projectId, group }
    };
}
exports.deleteGroupRequest = deleteGroupRequest;
const deleteGroupSuccess = () => ({
    type: ActionTypes.DELETE_GROUP_SUCCESS
});
exports.deleteGroupSuccess = deleteGroupSuccess;
function deleteGroupFailure(error) {
    return {
        type: ActionTypes.DELETE_GROUP_FAILURE,
        payload: error
    };
}
exports.deleteGroupFailure = deleteGroupFailure;
function updateCategoryRequest(projectId, name, description, categoryId) {
    return {
        type: ActionTypes.UPDATE_CATEGORY_REQUEST,
        payload: {
            projectId,
            name,
            description,
            categoryId
        }
    };
}
exports.updateCategoryRequest = updateCategoryRequest;
const updateCategorySuccess = () => ({
    type: ActionTypes.UPDATE_CATEGORY_SUCCESS
});
exports.updateCategorySuccess = updateCategorySuccess;
function updateCategoryFailure(error) {
    return {
        type: ActionTypes.UPDATE_CATEGORY_FAILURE,
        payload: error
    };
}
exports.updateCategoryFailure = updateCategoryFailure;
// User profile
const createUserProfileRequest = (projectId, categoryId, name, description, copiedProfileId, period) => ({
    type: ActionTypes.CREATE_USER_PROFILE_REQUEST,
    payload: {
        projectId,
        categoryId,
        name,
        description,
        copiedProfileId,
        period
    }
});
exports.createUserProfileRequest = createUserProfileRequest;
const createUserProfileSuccess = () => ({
    type: ActionTypes.CREATE_USER_PROFILE_SUCCESS
});
exports.createUserProfileSuccess = createUserProfileSuccess;
function createUserProfileFailure(error) {
    return {
        type: ActionTypes.CREATE_USER_PROFILE_FAILURE,
        payload: error
    };
}
exports.createUserProfileFailure = createUserProfileFailure;
const updateUserProfileRequest = (projectId, name, description, userProfileId, toCopy, copyType, period) => ({
    type: ActionTypes.UPDATE_USER_PROFILE_REQUEST,
    payload: {
        projectId,
        name,
        description,
        userProfileId,
        toCopy,
        copyType,
        period
    }
});
exports.updateUserProfileRequest = updateUserProfileRequest;
const updateUserProfileSuccess = () => ({
    type: ActionTypes.UPDATE_USER_PROFILE_SUCCESS
});
exports.updateUserProfileSuccess = updateUserProfileSuccess;
function updateUserProfileFailure(error) {
    return {
        type: ActionTypes.UPDATE_USER_PROFILE_FAILURE,
        payload: error
    };
}
exports.updateUserProfileFailure = updateUserProfileFailure;
// User worksite diary
const createWorksiteDiaryRequest = (projectId, name, worksitediarynumber) => ({
    type: ActionTypes.CREATE_WORKSITE_DIARY_REQUEST,
    payload: {
        projectId,
        name,
        worksitediarynumber
    }
});
exports.createWorksiteDiaryRequest = createWorksiteDiaryRequest;
const createWorksiteDiarySuccess = () => ({
    type: ActionTypes.CREATE_WORKSITE_DIARY_SUCCESS
});
exports.createWorksiteDiarySuccess = createWorksiteDiarySuccess;
const createWorksiteDiaryFailure = (error) => ({
    type: ActionTypes.CREATE_WORKSITE_DIARY_FAILURE,
    payload: error
});
exports.createWorksiteDiaryFailure = createWorksiteDiaryFailure;
function updateWorksiteDiaryRequest(projectId, name, worksitediaryId, worksitediarynumber) {
    return {
        type: ActionTypes.UPDATE_WORKSITE_DIARY_REQUEST,
        payload: {
            projectId,
            name,
            worksitediaryId,
            worksitediarynumber
        }
    };
}
exports.updateWorksiteDiaryRequest = updateWorksiteDiaryRequest;
const updateWorksiteDiarySuccess = () => ({
    type: ActionTypes.UPDATE_WORKSITE_DIARY_SUCCESS
});
exports.updateWorksiteDiarySuccess = updateWorksiteDiarySuccess;
function updateWorksiteDiaryFailure(error) {
    return {
        type: ActionTypes.UPDATE_WORKSITE_DIARY_FAILURE,
        payload: error
    };
}
exports.updateWorksiteDiaryFailure = updateWorksiteDiaryFailure;
// User TRMVRMeter
const createTRMVRMeterRequest = (projectId, name, meterType, siteNumber) => ({
    type: ActionTypes.CREATE_TRMVRMETER_REQUEST,
    payload: {
        projectId,
        name,
        meterType,
        siteNumber
    }
});
exports.createTRMVRMeterRequest = createTRMVRMeterRequest;
const createTRMVRMeterSuccess = () => ({
    type: ActionTypes.CREATE_TRMVRMETER_SUCCESS
});
exports.createTRMVRMeterSuccess = createTRMVRMeterSuccess;
const createTRMVRMeterFailure = (error) => ({
    type: ActionTypes.CREATE_TRMVRMETER_FAILURE,
    payload: error
});
exports.createTRMVRMeterFailure = createTRMVRMeterFailure;
function updateTRMVRMeterRequest(projectId, name, trmvrmeterId, meterType, siteNumber) {
    return {
        type: ActionTypes.UPDATE_TRMVRMETER_REQUEST,
        payload: {
            projectId,
            name,
            trmvrmeterId,
            meterType,
            siteNumber
        }
    };
}
exports.updateTRMVRMeterRequest = updateTRMVRMeterRequest;
const updateTRMVRMeterSuccess = () => ({
    type: ActionTypes.UPDATE_TRMVRMETER_SUCCESS
});
exports.updateTRMVRMeterSuccess = updateTRMVRMeterSuccess;
function updateTRMVRMeterFailure(error) {
    return {
        type: ActionTypes.UPDATE_TRMVRMETER_FAILURE,
        payload: error
    };
}
exports.updateTRMVRMeterFailure = updateTRMVRMeterFailure;
// Combined deletion payload
const deleteGroupsUsersRequest = (projectId, users, context) => ({
    type: ActionTypes.DELETE_GROUPS_USERS_REQUEST,
    payload: {
        projectId,
        users,
        context
    }
});
exports.deleteGroupsUsersRequest = deleteGroupsUsersRequest;
const deleteGroupsUsersSuccess = () => ({
    type: ActionTypes.DELETE_GROUPS_USERS_SUCCESS
});
exports.deleteGroupsUsersSuccess = deleteGroupsUsersSuccess;
function deleteGroupsUsersFailure(error) {
    return {
        type: ActionTypes.DELETE_GROUPS_USERS_FAILURE,
        payload: error
    };
}
exports.deleteGroupsUsersFailure = deleteGroupsUsersFailure;
// User category & user profile (user group) shared actions
const modifyProjectUserGroup = (mode, type, name, description, id, validSince, validUntil, siteNumber, inviteRightsTo) => ({
    type: ActionTypes.MODIFY_PROJECT_USER_GROUP,
    payload: {
        mode,
        name,
        description,
        id,
        type,
        validSince,
        validUntil,
        siteNumber,
        inviteRightsTo
    }
});
exports.modifyProjectUserGroup = modifyProjectUserGroup;
const setUserGroupName = (name) => ({
    type: ActionTypes.SET_USER_GROUP_NAME,
    payload: name
});
exports.setUserGroupName = setUserGroupName;
const deleteEdit = (mode, type, name, id) => ({
    type: ActionTypes.DELETE_EDIT,
    payload: {
        mode,
        name,
        id,
        type
    }
});
exports.deleteEdit = deleteEdit;
// Users
function deleteUsersRequest(projectId, items) {
    return {
        type: ActionTypes.DELETE_USERS_REQUEST,
        payload: { projectId, items }
    };
}
exports.deleteUsersRequest = deleteUsersRequest;
const deleteUsersSuccess = () => ({
    type: ActionTypes.DELETE_USERS_SUCCESS
});
exports.deleteUsersSuccess = deleteUsersSuccess;
function deleteUsersFailure(error) {
    return {
        type: ActionTypes.DELETE_USERS_FAILURE,
        payload: error
    };
}
exports.deleteUsersFailure = deleteUsersFailure;
const toggleMoveCopyUserToGroup = (open, type) => ({
    type: ActionTypes.TOGGLE_MOVE_COPY_USER_TO_GROUP,
    payload: {
        open,
        type
    }
});
exports.toggleMoveCopyUserToGroup = toggleMoveCopyUserToGroup;
const moveCopyUserToGroup = (type) => ({
    type: ActionTypes.MOVE_COPY_USER_TO_USER_GROUP,
    payload: type
});
exports.moveCopyUserToGroup = moveCopyUserToGroup;
const moveCopyUsersToGroupSaveRequest = (projectId, users, group) => ({
    type: ActionTypes.MOVE_COPY_USER_TO_USER_GROUP_SAVE_REQUEST,
    payload: {
        projectId,
        users,
        group
    }
});
exports.moveCopyUsersToGroupSaveRequest = moveCopyUsersToGroupSaveRequest;
const moveCopyUsersToGroupSaveFailure = (error) => ({
    type: ActionTypes.MOVE_COPY_USER_TO_USER_GROUP_SAVE_FAILURE,
    data: {
        error
    }
});
exports.moveCopyUsersToGroupSaveFailure = moveCopyUsersToGroupSaveFailure;
const moveCopyUsersToGroupSaveSuccess = () => ({
    type: ActionTypes.MOVE_COPY_USER_TO_USER_GROUP_SAVE_SUCCESS
});
exports.moveCopyUsersToGroupSaveSuccess = moveCopyUsersToGroupSaveSuccess;
//# sourceMappingURL=members.js.map